(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-featured-tour-dates"] && !Shopify.designMode) return;
  try {
    
  class TourDatesList extends HTMLElement {
    connectedCallback() {
      this.listEl = this.querySelector('[data-tour-dates-list]');
      this.fallbackEl = this.querySelector('[data-tour-dates-fallback]');
      this.appId = this.dataset.appId;
      this.artist = this.dataset.artist;
      this.limit = parseInt(this.dataset.limit, 10) || 6;
      this.rsvpText = this.dataset.rsvpText || 'RSVP';
      this.ticketsText = this.dataset.ticketsText || 'Tickets →';
      this.waitlistText = this.dataset.waitlistText || 'Waitlist →';
      this.soldOutText = this.dataset.soldOutText || 'Sold Out';

      this.revealObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-inview');
              observer.unobserve(entry.target);
            });
          }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' })
        : null;

      if (!this.appId || !this.artist) {
        this.showFallback();
        return;
      }

      this.loadEvents();
    }

    async loadEvents() {
      try {
        const url = `https://rest.bandsintown.com/artists/${encodeURIComponent(this.artist)}/events/?app_id=${encodeURIComponent(this.appId)}`;
        const response = await fetch(url);

        if (!response.ok) {
          this.showFallback();
          return;
        }

        const events = await response.json();

        if (!Array.isArray(events) || events.length === 0) {
          this.showFallback();
          return;
        }

        const sorted = events
          .slice()
          .sort((a, b) => new Date(a.datetime) - new Date(b.datetime))
          .slice(0, this.limit);

        this.renderEvents(sorted);
      } catch (error) {
        this.showFallback();
      }
    }

    showFallback() {
      if (this.fallbackEl) this.fallbackEl.hidden = false;
      if (this.listEl) this.listEl.hidden = true;
    }

    renderEvents(events) {
      if (!this.listEl) return;

      const fragment = document.createDocumentFragment();
      events.forEach((event) => {
        const row = this.buildRow(event);
        fragment.appendChild(row);
        if (this.revealObserver) this.revealObserver.observe(row);
      });

      this.listEl.innerHTML = '';
      this.listEl.appendChild(fragment);
    }

    buildRow(event) {
      const date = new Date(event.datetime);
      const dateLabel = `${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}.${String(date.getFullYear()).slice(-2)}`;
      const dayLabel = date.toLocaleDateString('en-US', { weekday: 'long' }).toUpperCase();

      const venue = event.venue || {};
      const cityLabel = [venue.city, venue.region || venue.country].filter(Boolean).join(', ');
      const venueLabel = venue.name || '';

      const offers = Array.isArray(event.offers) ? event.offers : [];
      const ticketOffer = offers.find((offer) => offer.type === 'Tickets') || offers[0];
      const soldOut = Boolean(ticketOffer) && ticketOffer.status === 'unavailable';
      const rsvpUrl = `${event.url}&trigger=rsvp_going`;

      const row = document.createElement('div');
      row.className = 'custom-tour-dates__row';

      const info = document.createElement('div');
      info.className = 'custom-tour-dates__info';

      const dateCol = document.createElement('div');
      dateCol.className = 'custom-tour-dates__date-col';
      dateCol.appendChild(this.textEl('p', 'custom-tour-dates__date', dateLabel));
      dateCol.appendChild(this.textEl('p', 'custom-tour-dates__day', dayLabel));
      info.appendChild(dateCol);

      const locationCol = document.createElement('div');
      locationCol.className = 'custom-tour-dates__location-col';
      locationCol.appendChild(this.textEl('p', 'custom-tour-dates__city', cityLabel));
      locationCol.appendChild(this.textEl('p', 'custom-tour-dates__venue', venueLabel));
      info.appendChild(locationCol);

      row.appendChild(info);

      const actions = document.createElement('div');
      actions.className = 'custom-tour-dates__actions';

      if (soldOut) {
        actions.appendChild(this.textEl('span', 'custom-tour-dates__badge custom-tour-dates__badge--sold-out', this.soldOutText));
      }

      const buttons = document.createElement('div');
      buttons.className = 'custom-tour-dates__buttons';

      buttons.appendChild(this.linkEl('custom-tour-dates__button custom-tour-dates__button--rsvp', rsvpUrl, this.rsvpText));

      if (ticketOffer) {
        const buttonClass = soldOut
          ? 'custom-tour-dates__button custom-tour-dates__button--waitlist'
          : 'custom-tour-dates__button custom-tour-dates__button--tickets';
        const buttonText = soldOut ? this.waitlistText : this.ticketsText;
        buttons.appendChild(this.linkEl(buttonClass, ticketOffer.url, buttonText));
      }

      actions.appendChild(buttons);
      row.appendChild(actions);

      return row;
    }

    textEl(tag, className, text) {
      const el = document.createElement(tag);
      el.className = className;
      el.textContent = text;
      return el;
    }

    linkEl(className, href, text) {
      const a = document.createElement('a');
      a.className = className;
      a.href = href;
      a.textContent = text;
      a.target = '_blank';
      a.rel = 'noopener';
      return a;
    }
  }

  customElements.define('tour-dates-list', TourDatesList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class HeaderMobileMenu extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.custom-header__hamburger');
      this.panel = this.querySelector('.custom-header__mobile-panel');

      this.closeButton = this.querySelector('.custom-header__mobile-close');

      this.button.addEventListener('click', this.toggle.bind(this));
      this.closeButton.addEventListener('click', this.close.bind(this));
      this.panel.addEventListener('click', (event) => {
        if (event.target.closest('a')) this.close();
      });
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });
    }

    toggle() {
      const isOpen = this.button.getAttribute('aria-expanded') === 'true';
      isOpen ? this.close() : this.open();
    }

    open() {
      this.button.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
      this.classList.add('is-open');
      document.body.classList.add('custom-header-menu-open');
    }

    close() {
      this.button.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
      this.classList.remove('is-open');
      document.body.classList.remove('custom-header-menu-open');
    }
  }

  customElements.define('header-mobile-menu', HeaderMobileMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-music-feature"] && !Shopify.designMode) return;
  try {
    
  class MusicFeatureColumns extends HTMLElement {
    connectedCallback() {
      this.coverArt = this.querySelector('.custom-music-feature__cover-art');
      this.body = this.querySelector('.custom-music-feature__body');
      this.mql = window.matchMedia('(min-width: 1400px)');

      this.resizeObserver = new ResizeObserver(() => this.sync());
      this.resizeObserver.observe(this.body);
      this.mql.addEventListener('change', () => this.sync());
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    sync() {
      if (this.mql.matches) {
        const height = Math.round(this.body.getBoundingClientRect().height);
        const clamped = Math.min(1000, Math.max(200, height));
        this.coverArt.style.setProperty('--cover-art-size', `${clamped}px`);
      } else {
        this.coverArt.style.removeProperty('--cover-art-size');
      }
    }
  }

  customElements.define('music-feature-columns', MusicFeatureColumns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-next-tour-date"] && !Shopify.designMode) return;
  try {
    
  class NextTourDate extends HTMLElement {
    connectedCallback() {
      this.contentEl = this.querySelector('[data-next-tour-date-content]');
      this.fallbackEl = this.querySelector('[data-next-tour-date-fallback]');
      this.appId = this.dataset.appId;
      this.artist = this.dataset.artist;
      this.nextShowLabel = this.dataset.nextShowLabel || '// Next Show';
      this.onSaleText = this.dataset.onSaleText || 'On Sale';
      this.soldOutText = this.dataset.soldOutText || 'Sold Out';
      this.ticketsText = this.dataset.ticketsText || 'Get Tickets →';
      this.waitlistText = this.dataset.waitlistText || 'Waitlist →';
      this.rsvpText = this.dataset.rsvpText || 'RSVP →';

      if (!this.appId || !this.artist) {
        this.showFallback();
        return;
      }

      this.loadNextEvent();
    }

    async loadNextEvent() {
      try {
        const url = `https://rest.bandsintown.com/artists/${encodeURIComponent(this.artist)}/events/?app_id=${encodeURIComponent(this.appId)}`;
        const response = await fetch(url);

        if (!response.ok) {
          this.showFallback();
          return;
        }

        const events = await response.json();

        if (!Array.isArray(events) || events.length === 0) {
          this.showFallback();
          return;
        }

        const next = events
          .slice()
          .sort((a, b) => new Date(a.datetime) - new Date(b.datetime))[0];

        this.renderEvent(next);
      } catch (error) {
        this.showFallback();
      }
    }

    showFallback() {
      if (this.fallbackEl) this.fallbackEl.hidden = false;
      if (this.contentEl) this.contentEl.hidden = true;
    }

    renderEvent(event) {
      if (!this.contentEl) return;

      const date = new Date(event.datetime);
      const dateLabel = `${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}.${String(date.getFullYear()).slice(-2)}`;
      const dayLabel = date.toLocaleDateString('en-US', { weekday: 'long' }).toUpperCase();

      const venue = event.venue || {};
      const cityLabel = [venue.city, venue.region || venue.country].filter(Boolean).join(', ');
      const venueLabel = venue.name || '';

      const offers = Array.isArray(event.offers) ? event.offers : [];
      const ticketOffer = offers.find((offer) => offer.type === 'Tickets') || offers[0];
      const soldOut = Boolean(ticketOffer) && ticketOffer.status === 'unavailable';
      const rsvpUrl = `${event.url}&trigger=rsvp_going`;

      const columns = document.createElement('div');
      columns.className = 'custom-next-tour-date__columns';

      const info = document.createElement('div');
      info.className = 'custom-next-tour-date__info';

      const dateCol = document.createElement('div');
      dateCol.className = 'custom-next-tour-date__date-col';
      dateCol.appendChild(this.textEl('p', 'custom-next-tour-date__label', this.nextShowLabel));
      dateCol.appendChild(this.textEl('p', 'custom-next-tour-date__date', dateLabel));
      dateCol.appendChild(this.textEl('p', 'custom-next-tour-date__day', dayLabel));
      info.appendChild(dateCol);

      const locationCol = document.createElement('div');
      locationCol.className = 'custom-next-tour-date__location-col';
      locationCol.appendChild(this.textEl('p', 'custom-next-tour-date__city', cityLabel));
      locationCol.appendChild(this.textEl('p', 'custom-next-tour-date__venue', venueLabel));
      info.appendChild(locationCol);

      columns.appendChild(info);

      const actions = document.createElement('div');
      actions.className = 'custom-next-tour-date__actions';
      actions.appendChild(
        this.textEl(
          'span',
          'custom-next-tour-date__button custom-next-tour-date__button--status',
          soldOut ? this.soldOutText : this.onSaleText
        )
      );

      if (ticketOffer) {
        const buttonText = soldOut ? this.waitlistText : this.ticketsText;
        actions.appendChild(this.linkEl('custom-next-tour-date__button custom-next-tour-date__button--tickets', ticketOffer.url, buttonText));
      } else {
        actions.appendChild(this.linkEl('custom-next-tour-date__button custom-next-tour-date__button--tickets', rsvpUrl, this.rsvpText));
      }

      columns.appendChild(actions);

      this.contentEl.innerHTML = '';
      this.contentEl.appendChild(columns);
      this.contentEl.hidden = false;

      this.dispatchEvent(new CustomEvent('brace:content-injected', { bubbles: true }));
    }

    textEl(tag, className, text) {
      const el = document.createElement(tag);
      el.className = className;
      el.textContent = text;
      return el;
    }

    linkEl(className, href, text) {
      const a = document.createElement('a');
      a.className = className;
      a.href = href;
      a.textContent = text;
      a.target = '_blank';
      a.rel = 'noopener';
      return a;
    }
  }

  customElements.define('next-tour-date', NextTourDate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-tour-dates"] && !Shopify.designMode) return;
  try {
    
  class TourDatesFullList extends HTMLElement {
    connectedCallback() {
      this.listEl = this.querySelector('[data-tour-list]');
      this.fallbackEl = this.querySelector('[data-tour-list-fallback]');
      this.appId = this.dataset.appId;
      this.artist = this.dataset.artist;
      this.rsvpText = this.dataset.rsvpText || 'RSVP';
      this.ticketsText = this.dataset.ticketsText || 'Tickets →';
      this.waitlistText = this.dataset.waitlistText || 'Waitlist →';
      this.soldOutText = this.dataset.soldOutText || 'Sold Out';

      this.revealObserver = 'IntersectionObserver' in window
        ? new IntersectionObserver((entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-inview');
              observer.unobserve(entry.target);
            });
          }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' })
        : null;

      if (!this.appId || !this.artist) {
        this.showFallback();
        return;
      }

      this.loadEvents();
    }

    async loadEvents() {
      try {
        const url = `https://rest.bandsintown.com/artists/${encodeURIComponent(this.artist)}/events/?app_id=${encodeURIComponent(this.appId)}`;
        const response = await fetch(url);

        if (!response.ok) {
          this.showFallback();
          return;
        }

        const events = await response.json();

        if (!Array.isArray(events) || events.length === 0) {
          this.showFallback();
          return;
        }

        const sorted = events
          .slice()
          .sort((a, b) => new Date(a.datetime) - new Date(b.datetime));

        this.renderEvents(sorted);
      } catch (error) {
        this.showFallback();
      }
    }

    showFallback() {
      if (this.fallbackEl) this.fallbackEl.hidden = false;
      if (this.listEl) this.listEl.hidden = true;
    }

    renderEvents(events) {
      if (!this.listEl) return;

      const fragment = document.createDocumentFragment();
      events.forEach((event) => {
        const row = this.buildRow(event);
        fragment.appendChild(row);
        if (this.revealObserver) this.revealObserver.observe(row);
      });

      this.listEl.innerHTML = '';
      this.listEl.appendChild(fragment);
    }

    buildRow(event) {
      const date = new Date(event.datetime);
      const dateLabel = `${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}.${String(date.getFullYear()).slice(-2)}`;
      const dayLabel = date.toLocaleDateString('en-US', { weekday: 'long' }).toUpperCase();

      const venue = event.venue || {};
      const cityLabel = [venue.city, venue.region || venue.country].filter(Boolean).join(', ');
      const venueLabel = venue.name || '';

      const offers = Array.isArray(event.offers) ? event.offers : [];
      const ticketOffer = offers.find((offer) => offer.type === 'Tickets') || offers[0];
      const soldOut = Boolean(ticketOffer) && ticketOffer.status === 'unavailable';
      const rsvpUrl = `${event.url}&trigger=rsvp_going`;

      const row = document.createElement('div');
      row.className = 'custom-tour-list__row';

      const info = document.createElement('div');
      info.className = 'custom-tour-list__info';

      const dateCol = document.createElement('div');
      dateCol.className = 'custom-tour-list__date-col';
      dateCol.appendChild(this.textEl('p', 'custom-tour-list__date', dateLabel));
      dateCol.appendChild(this.textEl('p', 'custom-tour-list__day', dayLabel));
      info.appendChild(dateCol);

      const locationCol = document.createElement('div');
      locationCol.className = 'custom-tour-list__location-col';
      locationCol.appendChild(this.textEl('p', 'custom-tour-list__city', cityLabel));
      locationCol.appendChild(this.textEl('p', 'custom-tour-list__venue', venueLabel));
      info.appendChild(locationCol);

      row.appendChild(info);

      const actions = document.createElement('div');
      actions.className = 'custom-tour-list__actions';

      if (soldOut) {
        actions.appendChild(this.textEl('span', 'custom-tour-list__badge custom-tour-list__badge--sold-out', this.soldOutText));
      }

      const buttons = document.createElement('div');
      buttons.className = 'custom-tour-list__buttons';

      buttons.appendChild(this.linkEl('custom-tour-list__button custom-tour-list__button--rsvp', rsvpUrl, this.rsvpText));

      if (ticketOffer) {
        const buttonClass = soldOut
          ? 'custom-tour-list__button custom-tour-list__button--waitlist'
          : 'custom-tour-list__button custom-tour-list__button--tickets';
        const buttonText = soldOut ? this.waitlistText : this.ticketsText;
        buttons.appendChild(this.linkEl(buttonClass, ticketOffer.url, buttonText));
      }

      actions.appendChild(buttons);
      row.appendChild(actions);

      return row;
    }

    textEl(tag, className, text) {
      const el = document.createElement(tag);
      el.className = className;
      el.textContent = text;
      return el;
    }

    linkEl(className, href, text) {
      const a = document.createElement('a');
      a.className = className;
      a.href = href;
      a.textContent = text;
      a.target = '_blank';
      a.rel = 'noopener';
      return a;
    }
  }

  customElements.define('tour-dates-full-list', TourDatesFullList);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
